/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import { RCCAlert,RCCGrid, RCCIcon, RCCPopover } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { v4 } from "uuid";
import Container from "src/components/List/styles";
import { useForm } from "react-hook-form";
import InfiniteScrollWithoutFetch from "src/components/InfiniteScrollWithoutFetch";
import { IComponentListFields } from "./interface";
import {StyledSpan}  from "./styles";
import ItemList from "./itemList";

const ListFields: React.FC<IComponentListFields> = ({
	data,
	clickField,
	showOnlyDescription
}) => {

	const { translate } = useTranslation();

	const fieldsName = "fields";
	const { 
		register,
		control,
		watch
	} = useForm();

	return (
		<>
    	<Container 
				layout="table"
			>
				{!data || data.length === 0 ? (
					<RCCAlert 
						title={translate("Atenção")}	
						description={translate("Não foram encontrados resultados para esta pesquisa")}
					/>
				): (


					<>
						{/* Header */}
						<li className="list-component-header">
							<RCCGrid
								item
								container
								xs={1}
							/>
							<RCCGrid
								item
								container
								alignItems="center"
								xs={showOnlyDescription ? 11 : 5}
								justifyContent="flex-start"
							>
								<StyledSpan
									bold
								>
									{translate("Descrição")}
								</StyledSpan>
							</RCCGrid>
							{showOnlyDescription !== true && (
								<>
									<RCCGrid
										item
										container
										alignItems="center"
										xs={2}
										justifyContent="flex-start"
									>
										<StyledSpan
											bold
										>
											{translate("Meta")}
										</StyledSpan>
									</RCCGrid>
									<RCCGrid
										item
										container
										alignItems="center"
										xs={4}
										justifyContent="flex-start"
										spacing={1}
									>
										<StyledSpan
											bold
										>
											{translate("Período")}	
										</StyledSpan>
										<RCCPopover
											header= {{
												title: translate("Como funciona os períodos")
											}}
											position="bottom"
											body= {{
												custom:
											<div className="popover-body"> 
												<p>{translate("Utilize períodos anteriores ou posteriores para buscar valor do campo de outros períodos")}.</p>
												<p>{translate("Por exemplo, período anterior - 1, quando estiver no período mensal Fevereiro, irá buscar o valor correspondente ao período de Janeiro")}.</p>
											</div>
											}}
										>
											<RCCIcon name="infoCircle" style={{ marginLeft: "4px" }}/>
										</RCCPopover>
									</RCCGrid>
								</>
							)}	
						</li>
						{/* List */}

						<InfiniteScrollWithoutFetch 
							listElements={data}
							mapper={(dt: any, index) => (	
								<React.Fragment key={v4()}>
									<ItemList 
										control={control}
										data={dt}
										fieldsName={fieldsName}
										index={index ?? 0}
										watch={watch}
										register={register}
										clickField={clickField}
										selected={dt.hasLink}
										showOnlyDescription={showOnlyDescription}
									/>
								</React.Fragment>)}
							defaultNumberOfElements={40}
							manuallyToggleShowMore
						/>
					</>
				
				
				
				)}
			</Container>
			
		</>
	);
};

export default ListFields;
